import React, { useEffect, useState, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import FilterBuilder from 'devextreme-react/filter-builder'
import { Button } from 'devextreme-react/button'
import axios from 'axios'
import notify from '../../utils/notify'
import { fixDataType, lookupStore } from '../../utils/model-data'
import { setExportActive } from '../../utils/model-data'

export default function ExportConfig() {
	const { process } = useParams()
	const navigate = useNavigate()

	const [fields, setFields] = useState<any[]>([])
	const [filter, setFilter] = useState<any>([])
	const [text, setText] = useState('')
	const [defaultFilter, setDefaultFilter] = useState<any>(null)

	useEffect(() => {
		axios
			.get(`${API_FIBER_URL}/exports/meta/${process}`)
			.then(res => res.data)
			.then(data => {
				if (!data.success) throw new Error('Export metadata not found')

				const processedFields = data.fields.map((field: any) => {
					const dataType = fixDataType(field.dataType, field.dataField)

					let lookupOptions = undefined
					if (data.lookups && data.lookups[field.dataField]) {
						lookupOptions = data.lookups[field.dataField].map((v: any) => ({ value: v, text: v }))
					}

					return {
						...field,
						dataType,
						editorOptions: lookupOptions
							? {
									dataSource: lookupOptions,
									valueExpr: 'value',
									displayExpr: 'text',
							  }
							: undefined,
						lookup: lookupOptions
							? {
									dataSource: lookupOptions,
									valueExpr: 'value',
									displayExpr: 'text',
							  }
							: undefined,
					}
				})
				setFields(processedFields)
				setText(data.text || '')
				if (data.defaultFilter?.length >= 2) {
					const filterValue =
						data.defaultFilter.length === 2 ? [...data.defaultFilter, ''] : data.defaultFilter
					setDefaultFilter(filterValue)
				}
			})
			.catch(() => {
				notify('Error loading export metadata', 'error')
			})
	}, [process, navigate])

	useEffect(() => {
		if (fields.length > 0 && defaultFilter) {
			setFilter(defaultFilter)
		}
	}, [fields, defaultFilter])

	const onValueChanged = useCallback((e: any) => {
		setFilter(e.value)
	}, [])

	const handleExport = () => {
		let cleanedFilter = filter

		const isEmptyFilter = (f: any): boolean => {
			if (!Array.isArray(f)) return false
			if (f.length === 3) return f[2] === '' || f[2] == null
			return f.every((item: any) => Array.isArray(item) && isEmptyFilter(item))
		}

		if (isEmptyFilter(cleanedFilter)) cleanedFilter = null

		setExportActive(true)
		axios
			.post(`${API_FIBER_URL}/exports/generate`, {
				process,
				filter: cleanedFilter ? JSON.stringify(cleanedFilter) : null,
			})
			.then(response => {
				if (response.data.success) {
					notify('Export started successfully', 'success')
				} else {
					setExportActive(false)
					notify(response.data.message, 'error')
				}
			})
			.catch(e => {
				setExportActive(false)
				const msg = e.response?.data?.message || 'Error starting export'
				notify(msg, 'error')
			})
	}

	return (
		<>
			<h2 className="content-block">
				<span className="dx-icon-exportxlsx" style={{ fontSize: '24px' }}></span> Export: {text}
			</h2>
			<div className="content-block dx-card responsive-paddings">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header">Configure Filters</div>
					<div className="dx-field">
						<div className="dx-field-value">
							<FilterBuilder
								fields={fields}
								value={filter}
								onValueChanged={onValueChanged}
								groupOperations={['and', 'or']}
							/>
						</div>
					</div>
				</div>
				<br />
				<Button text="Start Export" type="default" icon="exportxlsx" onClick={handleExport} />
			</div>
		</>
	)
}
